// extracted by mini-css-extract-plugin
export default {"title":"WeedingPassTable_title__kmAEu","total":"WeedingPassTable_total__QuLK1","pay":"WeedingPassTable_pay__YnMa4","edit":"WeedingPassTable_edit__JfWXs"};